export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";